export default __webpack_public_path__ + "assets/m1.73d8bf9c.png";